"use strict";
const angular = require("angular");

const uiRouter = require("angular-ui-router");

import routes from "./exposure.routes";
import _ from "lodash";

export class ExposureComponent {
  hideEdit = false;

  order = {
    field: "season",
    direction: true
  };

  chartConfig = {
    credits: {
      enabled: false
    },
    chart: {
      type: "line",
      height: 300
    },
    xAxis: {
      tickmarkPlacement: "on",
      title: {
        enabled: false
      },
      categories: []
    },
    series: [
      {
        name: "Guest Skier Days",
        id: "SkierDays"
      },
      {
        name: "Guide Skier Days",
        id: "GuideDays"
      },
      {
        name: "Pilot Flying Days",
        id: "PilotDays"
      },
      {
        name: "Staff Working Days",
        id: "StaffDays"
      }
    ],
    title: {
      text: "Seasonal Exposure"
    }
  };

  /*@ngInject*/
  constructor($http, appConfig, $uibModal, ngToast, Auth) {
    "ngInject";

    this.$uibModal = $uibModal;
    this.$http = $http;
    this.ngToast = ngToast;

    Auth.hasRole("admin").then(hasRole => {
      this.isAdmin = hasRole;
      this.hideEdit = hasRole;
    });
    Auth.hasRole("hccadmin").then(hasRole => {
      this.isAdmin = hasRole;
      this.hideEdit = hasRole;
    });
  }

  $onInit() {
    this.updateExposure();
  }

  download(days) {
    console.log("window open...");
    let win = window.open(
      `/api/seasonExposure/operationExposure.csv?days=${days}`
    );
    win.focus();

    // console.log("csv here");
    // this.$http.get("/api/seasonExposure/operations").then(response => {
    //   console.log(response.data);
    // });
  }

  updateExposure() {
    this.$http.get("/api/seasonExposure/").then(response => {
      this.exposure = response.data;

      this.exposure.forEach(season => {
        season.totalDays =
          season.skierDays +
          season.guideDays +
          season.pilotDays +
          season.staffDays;
      });

      this.chartConfig.series[0].data = _.map(this.exposure, e => e.skierDays);
      this.chartConfig.series[1].data = _.map(this.exposure, e => e.guideDays);
      this.chartConfig.series[2].data = _.map(this.exposure, e => e.pilotDays);
      this.chartConfig.series[3].data = _.map(this.exposure, e => e.staffDays);
      this.chartConfig.xAxis.categories = _.map(this.exposure, e => e.season);

      console.log(this.chartConfig.xAxis.categories);
      console.log("update to: ", this.chartConfig.series[0].data);
    });
  }

  sort(field) {
    if (this.order.field == field) {
      this.order.direction = !this.order.direction;
    } else {
      this.order.field = field;
      this.order.direction = true;
    }
  }

  addExposure() {
    if (this.hideEdit) {
      return;
    }

    let exposureModal = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("./addExposure.html"),
      controller: "AddExposureController",
      controllerAs: "$ctrl",
      resolve: {
        exposure() {}
      }
    });

    exposureModal.result.then(exposure => {
      if (!exposure) {
        return;
      }
      this.$http.post("/api/seasonExposure/", exposure).then(
        () => {
          this.updateExposure();
        },
        error => {
          if (error.data.name == "SequelizeUniqueConstraintError") {
            this.ngToast.create({
              className: "danger",
              content: "Error: There is already an entry for this season."
            });
          } else {
            this.ngToast.create({
              className: "danger",
              content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
            });
          }
          // this.ngToast.create("this is my message");
        }
      );
    });
  }

  editExposure(exposure) {
    if (this.hideEdit) {
      return;
    }
    let exposureModal = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("./addExposure.html"),
      controller: "AddExposureController",
      controllerAs: "$ctrl",
      resolve: {
        exposure() {
          console.log("returning exposure on resolve:", exposure);
          return _.clone(exposure);
        }
      }
    });

    exposureModal.result.then(exposureResult => {
      if (!exposureResult) {
        return;
      }
      console.log("PUT");
      this.$http.put(`/api/seasonExposure/${exposure.id}`, exposureResult).then(
        () => {
          this.updateExposure();
        },
        error => {
          this.ngToast.create({
            className: "danger",
            content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
          });
        }
      );
    });
  }
}

export default angular
  .module("hccApp.exposure", [uiRouter])
  .config(routes)
  .component("exposure", {
    template: require("./exposure.html"),
    controller: ExposureComponent
    // controllerAs: 'dashboardCtrl'
  }).name;



// WEBPACK FOOTER //
// ./client/app/exposure/exposure.component.js